export const getActiveFilters = <T extends Record<string, unknown>>(
  filters: T,
): Partial<T> => {
  const activeFiltersList = Object.entries(filters).filter(
    ([_, valueFilter]) => {
      if (Array.isArray(valueFilter) && !valueFilter.length) {
        return false;
      }

      return valueFilter || Number.isFinite(valueFilter);
    },
  );

  return Object.fromEntries(activeFiltersList) as Partial<T>;
};
